import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AuthContext } from 'contexts/AuthContext';
import { requiresClinicSetup } from 'utils/accessControl';

const AuthGuard = ({ children }) => {
  const { isLoggedIn, user } = useContext(AuthContext);
  const location = useLocation();

  const currentPath = location.pathname || window.location.pathname || '';
  const currentSearch = location.search || window.location.search || '';
  const isSetupRoute =
    currentPath.startsWith('/setup') ||
    currentPath.startsWith('/s/') ||
    currentPath.startsWith('/clinic-admin/setup') ||
    currentPath.startsWith('/clinic/setup') ||
    currentPath.startsWith('/clinic-admin/register') ||
    currentSearch.includes('token=') ||
    currentSearch.includes('clinic_id=') ||
    currentSearch.includes('t=');

  if (isSetupRoute) {
    return children;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (requiresClinicSetup(user) && !isSetupRoute) {
    return <Navigate to="/clinic-admin/setup" replace />;
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
